// extracted by mini-css-extract-plugin
module.exports = {"card":"TechCard_card__pTSBX","media":"TechCard_media___KJDX","videoPlayer":"TechCard_videoPlayer__Od031","logo":"TechCard_logo__O53E_"};